"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidEmailAddress = isValidEmailAddress;
exports.emailRegexString = void 0;
var emailRegexString = // Taken from this article. https://www.regular-expressions.info/email.html.
// Limitation: To prevent an over complicated regex, this regex does not limit email address length
"^([a-z0-9!#$%&'*+\\/=?^_‘{|}~-])+(?:\\.[a-z0-9!#$%&'*+\\/=?^_‘{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$";
exports.emailRegexString = emailRegexString;

function isValidEmailAddress(email) {
  var emailRegex = new RegExp(emailRegexString, 'i');
  var atIndex = email.indexOf('@'); // local-address must be <= 64 characters, complete-domain must be <= 255 characters and domain name must be <= 63 characters

  return emailRegex.test(email) && email.substring(0, atIndex).length <= 64 && email.substring(atIndex + 1).length <= 255 && email.substring(email.indexOf('.', atIndex + 1) + 1).length <= 63;
}